import Icon from '@ant-design/icons';
import { IconComponentProps } from '@ant-design/icons/lib/components/Icon';
import styled from '@emotion/styled';
import { ReactComponent as attachmentSvg } from './assets/attachment.svg';
import { ReactComponent as couponSvg } from './assets/coupon.svg';
import { ReactComponent as emojiSvg } from './assets/emoji.svg';
import { ReactComponent as foldSvg } from './assets/fold.svg';
import { ReactComponent as followSvg } from './assets/follow.svg';
import { ReactComponent as imageSvg } from './assets/image.svg';
import { ReactComponent as productSvg } from './assets/product.svg';
import { ReactComponent as replySvg } from './assets/reply.svg';
import { ReactComponent as translateSvg } from './assets/translate.svg';
import { ReactComponent as videoSvg } from './assets/video.svg';

import { cx } from '@emotion/css';
import { HTMLAttributes, useCallback } from 'react';

type IconProps = Pick<
  IconComponentProps,
  | 'max'
  | 'required'
  | 'default'
  | 'high'
  | 'low'
  | 'disabled'
  | 'start'
  | 'open'
  | 'media'
  | 'hidden'
  | 'cite'
  | 'data'
  | 'dir'
  | 'form'
  | 'label'
  | 'slot'
  | 'span'
  | 'style'
  | 'summary'
  | 'title'
  | 'pattern'
  | 'async'
  | 'defer'
  | 'manifest'
  | 'color'
  | 'content'
  | 'size'
  | 'wrap'
  | 'multiple'
  | 'height'
  | 'rotate'
  | 'translate'
  | 'width'
  | 'prefix'
  | 'src'
  | 'children'
  | 'key'
  | 'list'
  | 'step'
  | 'value'
  | 'aria-label'
  | 'viewBox'
  | 'component'
  | 'ariaLabel'
  | 'spin'
  | 'accept'
  | 'acceptCharset'
  | 'action'
  | 'allowFullScreen'
  | 'allowTransparency'
  | 'alt'
  | 'as'
  | 'autoComplete'
  | 'autoFocus'
  | 'autoPlay'
  | 'capture'
  | 'cellPadding'
  | 'cellSpacing'
  | 'charSet'
  | 'challenge'
  | 'checked'
  | 'classID'
  | 'cols'
  | 'colSpan'
  | 'controls'
  | 'coords'
  | 'crossOrigin'
  | 'dateTime'
  | 'download'
  | 'encType'
  | 'formAction'
  | 'formEncType'
  | 'formMethod'
  | 'formNoValidate'
  | 'formTarget'
  | 'frameBorder'
  | 'headers'
  | 'href'
  | 'hrefLang'
  | 'htmlFor'
  | 'httpEquiv'
  | 'integrity'
  | 'keyParams'
  | 'keyType'
  | 'kind'
  | 'loop'
  | 'marginHeight'
  | 'marginWidth'
  | 'maxLength'
  | 'mediaGroup'
  | 'method'
  | 'min'
  | 'minLength'
  | 'muted'
  | 'name'
  | 'nonce'
  | 'noValidate'
  | 'optimum'
  | 'placeholder'
  | 'playsInline'
  | 'poster'
  | 'preload'
  | 'readOnly'
  | 'rel'
  | 'reversed'
  | 'rows'
  | 'rowSpan'
  | 'sandbox'
  | 'scope'
  | 'scoped'
  | 'scrolling'
  | 'seamless'
  | 'selected'
  | 'shape'
  | 'sizes'
  | 'srcDoc'
  | 'srcLang'
  | 'srcSet'
  | 'target'
  | 'type'
  | 'useMap'
  | 'wmode'
  | 'defaultChecked'
  | 'defaultValue'
  | 'suppressContentEditableWarning'
  | 'suppressHydrationWarning'
  | 'accessKey'
  | 'className'
  | 'contentEditable'
  | 'contextMenu'
  | 'draggable'
  | 'id'
  | 'lang'
  | 'spellCheck'
  | 'tabIndex'
  | 'radioGroup'
  | 'role'
  | 'about'
  | 'datatype'
  | 'inlist'
  | 'property'
  | 'resource'
  | 'typeof'
  | 'vocab'
  | 'autoCapitalize'
  | 'autoCorrect'
  | 'autoSave'
  | 'itemProp'
  | 'itemScope'
  | 'itemType'
  | 'itemID'
  | 'itemRef'
  | 'results'
  | 'security'
  | 'unselectable'
  | 'inputMode'
  | 'is'
  | 'aria-activedescendant'
  | 'aria-atomic'
  | 'aria-autocomplete'
  | 'aria-busy'
  | 'aria-checked'
  | 'aria-colcount'
  | 'aria-colindex'
  | 'aria-colspan'
  | 'aria-controls'
  | 'aria-current'
  | 'aria-describedby'
  | 'aria-details'
  | 'aria-disabled'
  | 'aria-dropeffect'
  | 'aria-errormessage'
  | 'aria-expanded'
  | 'aria-flowto'
  | 'aria-grabbed'
  | 'aria-haspopup'
  | 'aria-hidden'
  | 'aria-invalid'
  | 'aria-keyshortcuts'
  | 'aria-labelledby'
  | 'aria-level'
  | 'aria-live'
  | 'aria-modal'
  | 'aria-multiline'
  | 'aria-multiselectable'
  | 'aria-orientation'
  | 'aria-owns'
  | 'aria-placeholder'
  | 'aria-posinset'
  | 'aria-pressed'
  | 'aria-readonly'
  | 'aria-relevant'
  | 'aria-required'
  | 'aria-roledescription'
  | 'aria-rowcount'
  | 'aria-rowindex'
  | 'aria-rowspan'
  | 'aria-selected'
  | 'aria-setsize'
  | 'aria-sort'
  | 'aria-valuemax'
  | 'aria-valuemin'
  | 'aria-valuenow'
  | 'aria-valuetext'
  | 'dangerouslySetInnerHTML'
  | 'onCopy'
  | 'onCopyCapture'
  | 'onCut'
  | 'onCutCapture'
  | 'onPaste'
  | 'onPasteCapture'
  | 'onCompositionEnd'
  | 'onCompositionEndCapture'
  | 'onCompositionStart'
  | 'onCompositionStartCapture'
  | 'onCompositionUpdate'
  | 'onCompositionUpdateCapture'
  | 'onFocus'
  | 'onFocusCapture'
  | 'onBlur'
  | 'onBlurCapture'
  | 'onChange'
  | 'onChangeCapture'
  | 'onBeforeInput'
  | 'onBeforeInputCapture'
  | 'onInput'
  | 'onInputCapture'
  | 'onReset'
  | 'onResetCapture'
  | 'onSubmit'
  | 'onSubmitCapture'
  | 'onInvalid'
  | 'onInvalidCapture'
  | 'onLoad'
  | 'onLoadCapture'
  | 'onError'
  | 'onErrorCapture'
  | 'onKeyDown'
  | 'onKeyDownCapture'
  | 'onKeyPress'
  | 'onKeyPressCapture'
  | 'onKeyUp'
  | 'onKeyUpCapture'
  | 'onAbort'
  | 'onAbortCapture'
  | 'onCanPlay'
  | 'onCanPlayCapture'
  | 'onCanPlayThrough'
  | 'onCanPlayThroughCapture'
  | 'onDurationChange'
  | 'onDurationChangeCapture'
  | 'onEmptied'
  | 'onEmptiedCapture'
  | 'onEncrypted'
  | 'onEncryptedCapture'
  | 'onEnded'
  | 'onEndedCapture'
  | 'onLoadedData'
  | 'onLoadedDataCapture'
  | 'onLoadedMetadata'
  | 'onLoadedMetadataCapture'
  | 'onLoadStart'
  | 'onLoadStartCapture'
  | 'onPause'
  | 'onPauseCapture'
  | 'onPlay'
  | 'onPlayCapture'
  | 'onPlaying'
  | 'onPlayingCapture'
  | 'onProgress'
  | 'onProgressCapture'
  | 'onRateChange'
  | 'onRateChangeCapture'
  | 'onSeeked'
  | 'onSeekedCapture'
  | 'onSeeking'
  | 'onSeekingCapture'
  | 'onStalled'
  | 'onStalledCapture'
  | 'onSuspend'
  | 'onSuspendCapture'
  | 'onTimeUpdate'
  | 'onTimeUpdateCapture'
  | 'onVolumeChange'
  | 'onVolumeChangeCapture'
  | 'onWaiting'
  | 'onWaitingCapture'
  | 'onAuxClick'
  | 'onAuxClickCapture'
  | 'onClick'
  | 'onClickCapture'
  | 'onContextMenu'
  | 'onContextMenuCapture'
  | 'onDoubleClick'
  | 'onDoubleClickCapture'
  | 'onDrag'
  | 'onDragCapture'
  | 'onDragEnd'
  | 'onDragEndCapture'
  | 'onDragEnter'
  | 'onDragEnterCapture'
  | 'onDragExit'
  | 'onDragExitCapture'
  | 'onDragLeave'
  | 'onDragLeaveCapture'
  | 'onDragOver'
  | 'onDragOverCapture'
  | 'onDragStart'
  | 'onDragStartCapture'
  | 'onDrop'
  | 'onDropCapture'
  | 'onMouseDown'
  | 'onMouseDownCapture'
  | 'onMouseEnter'
  | 'onMouseLeave'
  | 'onMouseMove'
  | 'onMouseMoveCapture'
  | 'onMouseOut'
  | 'onMouseOutCapture'
  | 'onMouseOver'
  | 'onMouseOverCapture'
  | 'onMouseUp'
  | 'onMouseUpCapture'
  | 'onSelect'
  | 'onSelectCapture'
  | 'onTouchCancel'
  | 'onTouchCancelCapture'
  | 'onTouchEnd'
  | 'onTouchEndCapture'
  | 'onTouchMove'
  | 'onTouchMoveCapture'
  | 'onTouchStart'
  | 'onTouchStartCapture'
  | 'onPointerDown'
  | 'onPointerDownCapture'
  | 'onPointerMove'
  | 'onPointerMoveCapture'
  | 'onPointerUp'
  | 'onPointerUpCapture'
  | 'onPointerCancel'
  | 'onPointerCancelCapture'
  | 'onPointerEnter'
  | 'onPointerEnterCapture'
  | 'onPointerLeave'
  | 'onPointerLeaveCapture'
  | 'onPointerOver'
  | 'onPointerOverCapture'
  | 'onPointerOut'
  | 'onPointerOutCapture'
  | 'onGotPointerCapture'
  | 'onGotPointerCaptureCapture'
  | 'onLostPointerCapture'
  | 'onLostPointerCaptureCapture'
  | 'onScroll'
  | 'onScrollCapture'
  | 'onWheel'
  | 'onWheelCapture'
  | 'onAnimationStart'
  | 'onAnimationStartCapture'
  | 'onAnimationEnd'
  | 'onAnimationEndCapture'
  | 'onAnimationIteration'
  | 'onAnimationIterationCapture'
  | 'onTransitionEnd'
  | 'onTransitionEndCapture'
> &
  React.RefAttributes<HTMLSpanElement>;

const BaseIcon = styled(Icon)`
  & > svg {
    width: 18px;
    height: 18px;
  }
`;

export const EmojiIcon = (props: IconProps) => <BaseIcon component={emojiSvg} {...props} />;

export const ImageIcon = (props: IconProps) => <BaseIcon component={imageSvg} {...props} />;

export const VideoIcon = (props: IconProps) => <BaseIcon component={videoSvg} {...props} />;

const ICON_MAP = {
  attachment: attachmentSvg,
  coupon: couponSvg,
  emoji: emojiSvg,
  fold: foldSvg,
  follow: followSvg,
  image: imageSvg,
  product: productSvg,
  reply: replySvg,
  translate: translateSvg,
  video: videoSvg,
};

export type ToolbarIconName = keyof typeof ICON_MAP;

interface ToolbarIconProps extends HTMLAttributes<HTMLSpanElement> {
  icon: ToolbarIconName;
  size?: number;
  disabled?: boolean;
}

export const ToolbarIcon = (props: ToolbarIconProps) => {
  const { icon: iconName, onClick, size = 20, disabled = false, className, ...rest } = props;

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLSpanElement>) => {
      if (disabled) {
        e.preventDefault();
        return;
      }
      onClick?.(e);
    },
    [disabled, onClick],
  );

  const IconComponent = ICON_MAP[iconName];

  return (
    <span
      {...rest}
      className={cx(
        'inline-flex items-center justify-center',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:opacity-80',
        className,
      )}
      style={{ width: size, height: size }}
      onClick={handleClick}
    >
      <IconComponent />
    </span>
  );
};
